import ConfirmationCheckboxes from './ConfirmationCheckboxes'

export default ConfirmationCheckboxes
